import React, { useEffect, useState } from 'react';
import AuthContext from './AuthContext';
import CustomLoadingOverlay from '../components/CustomLoadingOverlay'

const AuthProvider = ({
  children,
  domain = '',
  jnzAuthToken = '',
  jnzCompanyToken = '',
  jnzServiceToken = '',
  redirectIfAuthenticated = '',
  redirectIfNotAuthenticated = '',
  redirectIfNoCompany = ''
}) => {

  const [jnzAuthState, setJnzAuthState] = useState({ isLoading: true, isLogin: false, user: null, isCompanyLogin: false, permission: null, employee: null });

  const setAuthState = (state) => {
    setJnzAuthState({ ...jnzAuthState, ...state });
  }

  const redirect = {
    redirectIfAuthenticated,
    redirectIfNotAuthenticated,
    redirectIfNoCompany
  }

  useEffect(() => {
    async function initialize() {
      const jnzAuth = window?.['jnzauth'];
      if (!jnzAuth) return;

      jnzAuth.initialize({
        domain: domain,
        web_token: jnzAuthToken,
        company_token: jnzCompanyToken,
        service_token: jnzServiceToken
      });

      if (jnzAuth._initialize) {
        const token = await jnzAuth.getAuthState();
        if (!token) return setAuthState({ isLoading: false, isLogin: false, user: null });

        const profile = await jnzAuth.getProfile();
        if (!profile) return setAuthState({ isLoading: false, isLogin: false, user: null });

        const companyList = await jnzAuth.getCompanyList();
        if (!companyList?.length > 0) return setAuthState({ isLoading: false, isLogin: true, user: profile });

        const companyToken = await jnzAuth.getCompany();
        const isExist = companyList.filter(company => company.company_uuid === companyToken);
        if (!companyToken || !isExist) {
          jnzAuth.setCompany(companyList[0].company_uuid);
        }

        const employee = await jnzAuth.getEmployeeProfile();
        if (!employee) return setAuthState({ isLoading: false, isLogin: true, user: profile });

        const permission = await jnzAuth.getPermission();
        if (!permission) return setAuthState({ isLoading: false, isLogin: true, user: profile });

        return setAuthState({ isLoading: false, isLogin: true, user: profile, isCompanyLogin: true, employee: employee, permission: permission });
      }
    }

    initialize()
  }, [])


  const context = { ...jnzAuthState, redirect, setAuthState };

  return (
    <AuthContext.Provider value={context}>
      { 
        jnzAuthState.isLoading
          ? <CustomLoadingOverlay isLoading={true} />
          : children
      }
    </AuthContext.Provider>
  );
}

export default AuthProvider;
